import { LocationAddressDto } from '@app/api/dmc';

/**
 * Formats a given address object into a readable string representation.
 *
 * @param {LocationAddressDto} address - The address object containing details such as street name, building number, floor, room, subdivision, postal code, and city.
 * @return {string} A formatted address string. Returns an empty string if the input address is null or undefined.
 */
export function formatAddress(address: LocationAddressDto): string {
  if (!address) return '';

  const {
    streetName,
    buildingNumber,
    floorIdentification,
    roomIdentification,
    subDivisionName,
    postalCode,
    cityName,
  } = address;

  const parts: string[] = [];

  // Line 1: Street and building
  if (streetName || buildingNumber) {
    let line1 = `${streetName ?? ''} ${buildingNumber ?? ''}`.trim();

    if (floorIdentification || roomIdentification) {
      line1 += `, ${floorIdentification ?? ''}${roomIdentification ? '.' + roomIdentification : ''}`;
    }

    parts.push(line1 + ', ');

  }

  // Optional subdivision line
  if (subDivisionName) {
    parts.push(subDivisionName);
  }

  // Line 2: Postal code and city
  if (postalCode || cityName) {
    parts.push(`${postalCode ?? ''} ${cityName ?? ''}`.trim());
  }

  return parts.join('\n');
}
